import { useState, useRef, useEffect, useMemo } from 'react';
import SingleDropDown from '../SingleDropDown';
import { FormHelperText, TextField } from '@material-ui/core';
import { useStyles } from '../../Styles/styles';
import clsx from 'clsx';
import { isLicenseValid } from '../../utils/utils';

const LicenseNumberAndState = ({ handleChange, state, stateOptions, userRoles, driversLicense, disabled, directToPersonFrame = false, ...props }) => {
  const classes = useStyles();
  const [labelWidth, setLabelWidth] = useState(0);

  const inputLabel = useRef(null);

  const pidError = useMemo(() => {
    return isLicenseValid(driversLicense, state?.name)
  }, [driversLicense, state?.name])


  useEffect(() => {
    if (inputLabel.current) {
      setLabelWidth(inputLabel.current.offsetWidth);
    }
  }, [inputLabel]);

  return (
    <div className={classes.formControl} style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
      <FlexRow>
        <SingleDropDown
          handleChange={handleChange}
          stateName={"licenseState"}
          value={state}
          options={stateOptions}
          title={'State'}
          inputLabel={inputLabel}
          labelWidth={labelWidth}
          userRoles={userRoles}
          {...props}
        />
        <TextField
          data-cy="DriversLicense"
          inputProps={{ "data-cy": "driversLicense-input" }}
          InputLabelProps={{ shrink: true }}
          id="driversLicense-id"
          label="License"
          value={driversLicense || ""}
          name={"driversLicense"}
          onChange={(e) => handleChange(e, false)}
          onBlur={(e) => handleChange(e, true)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.target.blur();
            }
          }}
          disabled={disabled}
          style={{ marginLeft: '10px' }}
        />
      </FlexRow>
      {pidError.success === false && pidError.error && <FormHelperText className={clsx(classes.leftMarginMatch, classes.redLabel)}>{pidError.error}</FormHelperText>}
      {pidError.success === false && pidError.error && directToPersonFrame && <FormHelperText className={clsx(classes.leftMarginMatch, classes.redLabel)}>Please fix the above error in the Person Detail frame.</FormHelperText>}
    </div>
  );
}

const FlexRow = ({ children, ...props }) => {
  return (
    <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'end' }} {...props}>
      {children}
    </div>
  )
}

export default LicenseNumberAndState;